import { createFileRoute } from '@tanstack/react-router';
import DocsGroupSectionLanding from '@/components/Docs/DocsGroupSectionLanding';

export const Route = createFileRoute('/developers/v1/$section/')({
  component: DevelopersV1SectionLandingPage,
});

function DevelopersV1SectionLandingPage() {
  const { section } = Route.useParams();
  return (
    <DocsGroupSectionLanding group="developers" sectionSlug={section} version="v1" />
  );
}
